import React from 'react';
import { ClickAwayListener, IconButton, Tooltip } from '@mui/material';
import { ContentCopyRounded } from '@mui/icons-material';

function CopyButton({ textToCopy, size = 'small', fontSize = 'small', tooltip = 'Copied!', hoverText = '' }) {
    const [copied, setCopied] = React.useState(false);

    function handleCopy(event) {
        event.stopPropagation(); // In the case that this button is inside another clickable element, this prevents the click from causing the parent onClick to occur (e.g., a row in a table - such as inventory row)
        try {
            navigator.clipboard.writeText(textToCopy);
            setCopied(true);
        } catch (error) {
            console.error('Failed to copy text to clipboard:', error);
        }
    }

    return (
        <ClickAwayListener onClickAway={() => setCopied(false)}>
            <Tooltip 
                title={copied ? tooltip : (hoverText)} 
                placement='top' 
                arrow
            >
                <IconButton size={size} onClick={handleCopy}>
                    <ContentCopyRounded fontSize={fontSize} />
                </IconButton>
            </Tooltip>
        </ClickAwayListener>
    );
}

export default CopyButton;
